"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESpotOrderExecutionType = exports.EWsBinanceSpotMarketEventTypes = exports.EWsBinanceSpotEventsTypes = void 0;
var EWsBinanceSpotEventsTypes;
(function (EWsBinanceSpotEventsTypes) {
    EWsBinanceSpotEventsTypes["executionReport"] = "executionReport";
    EWsBinanceSpotEventsTypes["outboundAccountPosition"] = "outboundAccountPosition";
})(EWsBinanceSpotEventsTypes = exports.EWsBinanceSpotEventsTypes || (exports.EWsBinanceSpotEventsTypes = {}));
var EWsBinanceSpotMarketEventTypes;
(function (EWsBinanceSpotMarketEventTypes) {
    EWsBinanceSpotMarketEventTypes["individualTicker"] = "24hrTicker";
})(EWsBinanceSpotMarketEventTypes = exports.EWsBinanceSpotMarketEventTypes || (exports.EWsBinanceSpotMarketEventTypes = {}));
var ESpotOrderExecutionType;
(function (ESpotOrderExecutionType) {
    ESpotOrderExecutionType["NEW"] = "NEW";
    ESpotOrderExecutionType["CANCELED"] = "CANCELED";
    ESpotOrderExecutionType["REPLACED"] = "REPLACED";
    ESpotOrderExecutionType["REJECTED"] = "REJECTED";
    ESpotOrderExecutionType["TRADE"] = "TRADE";
    ESpotOrderExecutionType["EXPIRED"] = "EXPIRED";
    ESpotOrderExecutionType["MARKET"] = "MARKET";
    ESpotOrderExecutionType["TRADE_PREVENTION"] = "TRADE_PREVENTION";
})(ESpotOrderExecutionType = exports.ESpotOrderExecutionType || (exports.ESpotOrderExecutionType = {}));
